import Config from '@annunciate/core/dist/utils/config';
export const DEEPLINK_SCHEME = `${Config.APP_DEEP_LINK_SCHEME}://`;
//# sourceMappingURL=DEEPLINK_SCHEME.js.map